<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12.001" height="10.014" viewBox="0 0 12.001 10.014">
    <g id="arrow-right" transform="translate(12.001 10.012) rotate(180)">
      <path
        id="Path"
        d="M1,6H8.586L6.293,8.295A1,1,0,1,0,7.707,9.709l4-4a1,1,0,0,0,0-1.416l-4-4A1,1,0,1,0,6.293,1.709L8.586,4H1A1,1,0,0,0,1,6Z"
        transform="translate(0 -0.002)"
        fill="#931363"
      />
    </g>
  </svg>
</template>
